import { render, staticRenderFns } from "./Copiar_Formato_OtroPeriodo_Formato.vue?vue&type=template&id=8464f3a6&scoped=true"
import script from "./Copiar_Formato_OtroPeriodo_Formato.vue?vue&type=script&lang=js"
export * from "./Copiar_Formato_OtroPeriodo_Formato.vue?vue&type=script&lang=js"
import style0 from "./Copiar_Formato_OtroPeriodo_Formato.vue?vue&type=style&index=0&id=8464f3a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8464f3a6",
  null
  
)

export default component.exports